"use strict";

(function () {
    window.App = window.App || {};
    function App() {
    }

    App.prototype.goTo = function(name, opts) {
        name = name.toLowerCase();
        switch (name) {
            case 'charts': this.gotoCharts(opts); break;
            case 'chartstrc': this.gotoChartstrc(opts); break;
            case 'generator': this.gotoGenerator(opts); break;
            case 'analytics': this.gotoAnalytics(opts); break;
            case 'link' : this.goToReports(opts); break;
            case 'mallsplans' : this.gotoMallsplans(opts);
            case 'footfall' : this.goToReportsFF(opts);
        }
        return false;
    };

    App.prototype.createAndSubmitForm = function (options) {

    };

    App.prototype.goToGeneratorTRC = function (options) {
        var form_name
        this.createAndSubmitForm(options);
    };

    App.prototype.gotoChartstrc = function (options) {
        var year = options.year,
            month = options.month,
            project_id = options.project_id,
            project_name = options.project_name,
            target_name = options.target_name,
            chart_number = options.chart_number,
            grouping_flag = options.grouping_flag,
            grouping_id = options.grouping_id,
            grouping_name = options.grouping_name,
            param_title = options.param_title,
            session_id = options.session_id;

        if (!target_name) target_name = '_self';

        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        //забит жестко путь в stage3;
        tmp_form.action = window.App.pathuniversal + 'chart/';

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[y]';
        tmp_el.type = 'hidden';
        tmp_el.value = year;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[m]';
        tmp_el.type = 'hidden';
        tmp_el.value = month;
        tmp_form.appendChild(tmp_el);
        var i;
        if (typeof grouping_flag[0] !== 'undefined') {
            for (i=0;i<grouping_id.length;i++) {
                if (grouping_name !== "undefined") {
                    console.log('i='+i);
                    var tmp_el = document.createElement("input");
                    tmp_el.name = 'QueryFormChart[grouping_flag]';
                    tmp_el.type = 'hidden';
                    tmp_el.value = grouping_flag[i];
                    tmp_form.appendChild(tmp_el);
                    // Добавим input c параметром
                    var tmp_el = document.createElement("input");
                    tmp_el.name = 'QueryFormChart[grouping_id]';
                    tmp_el.type = 'hidden';
                    tmp_el.value = grouping_id[i];
                    tmp_form.appendChild(tmp_el);
                    // Добавим input c параметром
                    var tmp_el = document.createElement("input");
                    tmp_el.name = 'QueryFormChart[grouping_name][]';
                    tmp_el.type = 'hidden';
                    tmp_el.value = grouping_name[i];
                    tmp_form.appendChild(tmp_el);
                    // Добавим input c параметром
                    var tmp_el = document.createElement("input");
                    tmp_el.name = 'QueryFormChart[project_id][]';
                    tmp_el.type = 'hidden';
                    tmp_el.value = project_id[i];
                    tmp_form.appendChild(tmp_el);
                    // Добавим input c параметром
                    var tmp_el = document.createElement("input");
                    tmp_el.name = 'QueryFormChart[project_name][]';
                    tmp_el.type = 'hidden';
                    tmp_el.value = project_name[i];
                    tmp_form.appendChild(tmp_el);

                }
            }

        }



        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[param_title]';
        tmp_el.type = 'hidden';
        tmp_el.value = param_title;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[session_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = session_id;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[chart_number]';
        tmp_el.type = 'hidden';
        tmp_el.value = chart_number;
        tmp_form.appendChild(tmp_el);

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //console.log(tmp_form);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();

        setTimeout(function () {
            tmp_form.remove();
        }, 0);
    };

    App.prototype.gotoCharts = function (options) {
        var year = options.year,
            month = options.month,
            brand_id = options.brand_id,
            brand_name = options.brand_name,
            project_id = options.project_id,
            project_name = options.project_name,
            target_name = options.target_name,
            chart_number = options.chart_number,
            param_title = options.param_title,
            session_id = options.session_id;

        if (!target_name) target_name = '_self';

        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        //забит жестко путь в de3
        tmp_form.action = window.App.pathuniversal + 'chart/';

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[y]';
        tmp_el.type = 'hidden';
        tmp_el.value = year;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[m]';
        tmp_el.type = 'hidden';
        tmp_el.value = month;
        tmp_form.appendChild(tmp_el);
        var i;
        if (brand_id[0] !== 'undefined') {
            for (i=0;i<brand_id.length;i++) {
                // Добавим input c параметром
                var tmp_el = document.createElement("input");
                tmp_el.name = 'QueryFormChart[project_id][]';
                tmp_el.type = 'hidden';
                tmp_el.value = project_id[i];
                tmp_form.appendChild(tmp_el);
                // Добавим input c параметром
                var tmp_el = document.createElement("input");
                tmp_el.name = 'QueryFormChart[project_name][]';
                tmp_el.type = 'hidden';
                tmp_el.value = project_name[i];
                tmp_form.appendChild(tmp_el);
                // Добавим input c параметром
                var tmp_el = document.createElement("input");
                tmp_el.name = 'QueryFormChart[brand_id][]';
                tmp_el.type = 'hidden';
                tmp_el.value = brand_id[i];
                tmp_form.appendChild(tmp_el);
                // Добавим input c параметром
                var tmp_el = document.createElement("input");
                tmp_el.name = 'QueryFormChart[brand_name][]';
                tmp_el.type = 'hidden';
                tmp_el.value = brand_name[i];
                tmp_form.appendChild(tmp_el);

            }
        }

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[param_title]';
        tmp_el.type = 'hidden';
        tmp_el.value = param_title;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[session_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = session_id;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormChart[chart_number]';
        tmp_el.type = 'hidden';
        tmp_el.value = chart_number;
        tmp_form.appendChild(tmp_el);

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //console.log(tmp_form);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();

        setTimeout(function () {
            tmp_form.remove();
        }, 0);
    };

    App.prototype.goToReports = function (options) {
        var year = options.year,
            month = options.month,
            brand_id = options.brand_id,
            brand_name = options.brand_name,
            depth = options.depth,
            project_id = options.project_id,
            project_name = options.project_name,
            target_name = options.target_name;

        if (!target_name) target_name = '_self';

        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        //tmp_form.style.display='none';
        tmp_form.action = window.App.pathuniversal + 'reports/' + options.sublink;

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[y]';
        tmp_el.type = 'hidden';
        tmp_el.value = year;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[m]';
        tmp_el.type = 'hidden';
        tmp_el.value = month;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[project_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = project_id;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[project_name]';
        tmp_el.type = 'hidden';
        tmp_el.value = project_name;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[brand_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = brand_id;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[brand_name]';
        tmp_el.type = 'hidden';
        tmp_el.value = brand_name;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[depth]';
        tmp_el.type = 'hidden';
        tmp_el.value = depth;
        tmp_form.appendChild(tmp_el);

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();

        setTimeout(function () {
            tmp_form.remove();
        }, 0);
    };

    App.prototype.goToReportsFF = function (options) {
        var year = options.year,
            month = options.month,
            project_id = options.project_id,
            effect = options.effect,
            action_type = options.action_type,
            target_name = options.target_name;

        if (!target_name) target_name = '_blank';

        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        //tmp_form.style.display='none';
        tmp_form.action = window.App.pathuniversal + 'reports/footfall';

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[order_tab8_year]';
        tmp_el.type = 'hidden';
        tmp_el.value = year;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[order_tab8_month]';
        tmp_el.type = 'hidden';
        tmp_el.value = month;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[order_tab8_project_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = project_id;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[order_tab8_effect]';
        tmp_el.type = 'hidden';
        tmp_el.value = effect;
        tmp_form.appendChild(tmp_el);
        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormReports[order_tab8_action_type]';
        tmp_el.type = 'hidden';
        tmp_el.value = action_type;
        tmp_form.appendChild(tmp_el);

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();

        setTimeout(function () {
            tmp_form.remove();
        }, 0);
    };

    App.prototype.gotoAnalytics = function (options) {
        var project_id_in = options.project_id,
            brand_id_in = options.brand_id,
            period = options.period.split(';')[0],
            redirectAttr = options.redirectAttr || '_self';

        // Создать временную форму
        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = redirectAttr; // В планах ТРЦ открывать в новой вкладке
        //tmp_form.action = window.App.paths.to_analytics;
        tmp_form.action = window.App.pathuniversal + 'analytics/';
        tmp_form.style.display='none';
        document.getElementsByTagName('body')[0].appendChild(tmp_form);

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormAnalytics[project_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = project_id_in;
        tmp_form.appendChild(tmp_el);

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormAnalytics[brand_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = brand_id_in;
        tmp_form.appendChild(tmp_el);

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormAnalytics[period_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = period;
        tmp_form.appendChild(tmp_el);

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();
        setTimeout(function () { tmp_form.remove(); }, 0);
    };

    App.prototype.gotoMallsplans = function(options) {
        var project_id = options.project_id,
            target_name = options.target_name,
            level_id = options.level_id,
            period = options.period,
            indicator_id = options.indicator_id,
            action = options.action;

        if (!target_name) target_name = '_self';
        //alert(' y='+options.year+' m='+options.month+' brand_id='+options.brand_id+' depth='+options.depth+' project_id='+options.project_id+' project_name='+options.project_name+' sublink='+options.sublink);

        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        //tmp_form.style.display='none';
        tmp_form.action = action || window.App.pathuniversal + 'mallsplans/';

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = 'QueryFormMallsplans[project_id]';
        tmp_el.type = 'hidden';
        tmp_el.value = project_id;
        tmp_form.appendChild(tmp_el);

        if (level_id) {
            // Добавим input c параметром
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormMallsplans[level_id]';
            tmp_el.type = 'hidden';
            tmp_el.value = level_id;
            tmp_form.appendChild(tmp_el);
        }

        if (indicator_id) {
            // Добавим input c параметром
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormMallsplans[indicator_id]';
            tmp_el.type = 'hidden';
            tmp_el.value = indicator_id;
            tmp_form.appendChild(tmp_el);
        }

        if (period) {
            // Добавим input c параметром
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormMallsplans[period]';
            tmp_el.type = 'hidden';
            tmp_el.value = period;
            tmp_form.appendChild(tmp_el);
        }

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        console.log(tmp_form);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();

        setTimeout(function () { tmp_form.remove(); }, 0);
    }

    App.prototype.gotoGenerator = function (options) {
        /*
        * ссылка на генератор по брендам
        * Сковзные  [show_results = true, y, m, brand_name]
        * Сегмент   [show_results = true, y, m, project_name, sub_category_name, price_segment, category_sq_name, is_all_selects_show = true]
        * Этаж      [show_results = true, y, m, project_name, category_name, level_name, category_sq_name, is_all_selects_show = true]
        * Галерея   [show_results = true, y, m, project_name, category_name, gallery_name, category_sq_name, is_all_selects_show = true]
        * */
        var show_results = options.show_results,
            y = options.y,
            m = options.m,
            brand_name = options.brand_name,
            project_name = options.project_name,
            category_name = options.category_name,
            sub_category_name = options.sub_category_name,
            price_segment = options.price_segment,
            level_name = options.level_name,
            gallery_name = options.gallery_name,
            category_sq_name = options.category_sq_name,
            is_all_selects_show = options.is_all_selects_show,
            target_name = options.target_name;

        if (!target_name) target_name = '_blank';

        // Создать временную форму
        var tmp_form = document.createElement("form");
        tmp_form.method='post';
        tmp_form.target = target_name;
        tmp_form.action = window.App.pathuniversal + 'generator/';
        tmp_form.style.display='none';
        document.getElementsByTagName('body')[0].appendChild(tmp_form);

        // Добавим input c параметрами
        if (show_results) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[show_results]';
            tmp_el.type = 'hidden';
            tmp_el.value = show_results;
            tmp_form.appendChild(tmp_el);
        }
        if (y) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[y]';
            tmp_el.type = 'hidden';
            tmp_el.value = y;
            tmp_form.appendChild(tmp_el);
        }
        if (m) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[m]';
            tmp_el.type = 'hidden';
            tmp_el.value = m;
            tmp_form.appendChild(tmp_el);
        }
        if (brand_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[brand_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = brand_name;
            tmp_form.appendChild(tmp_el);
        }
        if (project_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[project_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = project_name;
            tmp_form.appendChild(tmp_el);
        }
        if (sub_category_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[sub_category_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = sub_category_name;
            tmp_form.appendChild(tmp_el);
        }
        if (price_segment) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[price_segment][]';
            tmp_el.type = 'hidden';
            tmp_el.value = price_segment;
            tmp_form.appendChild(tmp_el);
        }
        if (category_sq_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[category_sq_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = category_sq_name;
            tmp_form.appendChild(tmp_el);
        }
        if (is_all_selects_show) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[is_all_selects_show]';
            tmp_el.type = 'hidden';
            tmp_el.value = is_all_selects_show;
            tmp_form.appendChild(tmp_el);
        }
        if (category_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[category_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = category_name;
            tmp_form.appendChild(tmp_el);
        }
        if (level_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[level_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = level_name;
            tmp_form.appendChild(tmp_el);
        }
        if (gallery_name) {
            var tmp_el = document.createElement("input");
            tmp_el.name = 'QueryFormGenerator[gallery_name][]';
            tmp_el.type = 'hidden';
            tmp_el.value = gallery_name;
            tmp_form.appendChild(tmp_el);
        }

        var csrfToken = $('meta[name="csrf-token"]').attr("content");

        // Добавим input c параметром
        var tmp_el = document.createElement("input");
        tmp_el.name = '_csrf';
        tmp_el.type = 'hidden';
        tmp_el.value = csrfToken;
        tmp_form.appendChild(tmp_el);

        //добавим форму в документ, иначе не работает в мозиле и ие
        document.body.appendChild(tmp_form);

        // Отправить созданную форму
        tmp_form.submit();
        setTimeout(function () { tmp_form.remove(); }, 0);
    };

    App.prototype.addIconSelect2 = function ($target) {
        $target = $target || $('.select2-selection__arrow');
        var $formGroup = $target.closest('.form-group');
        var id = '';
        if ($formGroup.length > 0) { id = $formGroup.find('select').attr('id'); }
        $target.append('<i class="arrow-icon"></i>');
        /*if (id.indexOf('period') !== -1) {
            $target.append('<i class="summary-date__icon"></i>');
        } else {}*/
    };

    App.prototype.events = function () {};


    setTimeout(function () {
        window.App.__proto__ = Object.create(App.prototype);
        window.App.addIconSelect2();
    }, 400);


    $('.data-table-tr-js td').on('click', function (event) {
        var $currentTarget = $(event.currentTarget);
        var $target = $(event.currentTarget).parent('.data-table-tr-js');
        var $tdOnlick = $target.find('td[onclick]');

        if ($tdOnlick.length > 0 && $currentTarget.context.onclick == null) {
            $tdOnlick[0].onclick();
        }
    });


    $('.js-button-show').on('click', function () { // TODO: weird thing depends on get/post queries
        if (location.pathname.indexOf('reports/') !== -1) {
            $('#button-show-input').attr('value', !$('.js-button-show').hasClass('close'));
        } else {
            $('#button-show-input').attr('value', $('.js-button-show').hasClass('close'));
        }
    });

    $('.js-scroll-down-page').on('click', function () {
        setTimeout(function () {
            window.scrollTo(0,document.body.scrollHeight);
        }, 0);
    });
})();
